export default {"src":"/_next/static/image/public/images/flags/flag_597.003593fb84995b94924dcfe9970e65f2.svg","height":16,"width":24};